import { IdleConfig } from 'game/core'

export const idle_config: Array<IdleConfig> = [
    {
        available: 0,
        cooldown: 0,
        energy: 0
    }
]